var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel no-margin",class:[_vm.event.color],on:{"click":_vm.showEventDetails}},[_c('div',{staticClass:"panel-heading event-title",class:{'clickable-event':_vm.isDaySelected}},[_vm._v(_vm._s(_vm.event.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }